import { SxProps, Theme } from '@mui/material'
import { CELL_RADIUS, EMPTY_CELL_TEXT, SLATE_200 } from '../config/constants'

/** Lado del recuadro de muestra: una celda del mapa en miniatura. */
export const SWATCH_SIZE = 14

export const mapLegendStyles = {
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 1,
    alignItems: 'center',
  } as SxProps<Theme>,

  item: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
  } as SxProps<Theme>,

  /** `background` y no `bgcolor`: `fill` puede ser el gradiente del rayado. */
  swatch: (fill: string): SxProps<Theme> => ({
    width: SWATCH_SIZE,
    height: SWATCH_SIZE,
    borderRadius: CELL_RADIUS,
    border: '1px solid rgba(0,0,0,0.12)',
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    background: fill,
  }),

  /** Separa los tramos del modo activo de los estados de posición. */
  divider: {
    width: '1px',
    height: 18,
    bgcolor: SLATE_200,
    mx: 0.5,
    flexShrink: 0,
  } as SxProps<Theme>,

  emptyMarker: {
    fontSize: '0.5rem',
    color: EMPTY_CELL_TEXT,
    fontWeight: 600,
    lineHeight: 1,
  } as SxProps<Theme>,

  lockIcon: { fontSize: 10, color: 'rgba(0,0,0,0.55)' } as SxProps<Theme>,
}
